import * as React from "react";
import { useState } from "react";
import { Formik, Form, useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import useHistory from "routing/useHistory";
import { Alert, Col, Row } from "components/bootstrap";
import DocumentTitle from "components/common/DocumentTitle";
import FormSubmit from "components/common/FormSubmit";
import PageHeader from "components/common/PageHeader";
import i18n from "i18n";
const CreatePageContent = ({
  entityName,
  onCancel,
  description = void 0,
  documentationLink = void 0,
  submitError,
  children
}) => {
  const { t } = useTranslation("common");
  const { isSubmitting, isValidating, isValid } = useFormikContext();
  const title = t("create_entity.title", { entityName });
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title }, /* @__PURE__ */ React.createElement(PageHeader, { title, documentationLink }, description && /* @__PURE__ */ React.createElement("span", null, description)), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { lg: 8 }, /* @__PURE__ */ React.createElement(Form, null, children, submitError && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", title: t("create_entity.save_failed") }, submitError), /* @__PURE__ */ React.createElement(
    FormSubmit,
    {
      submitButtonText: t("create_entity.submit", { entityName }),
      submitLoadingText: t("create_entity.submitting", { entityName }),
      isSubmitting,
      isAsyncSubmit: true,
      disabledSubmit: !isValid || isValidating,
      onCancel
    }
  )))));
};
const CreatePage = ({
  entityName,
  overviewRoute,
  detailsRoute,
  initialValues,
  onSubmit,
  validate = void 0,
  description = void 0,
  documentationLink = void 0,
  children
}) => {
  const [submitError, setSubmitError] = useState(null);
  const history = useHistory();
  const handleCancel = () => window.history.length > 1 ? history.goBack() : history.push(overviewRoute);
  const handleSubmit = async (values) => {
    var _a;
    setSubmitError(null);
    try {
      const { id } = await onSubmit(values);
      history.push(detailsRoute(id));
    } catch (error) {
      setSubmitError((_a = error == null ? void 0 : error.message) != null ? _a : i18n.t("create_entity.unknown_error", { ns: "common" }));
    }
  };
  return /* @__PURE__ */ React.createElement(Formik, { initialValues, onSubmit: handleSubmit, validate, validateOnBlur: false }, /* @__PURE__ */ React.createElement(
    CreatePageContent,
    {
      entityName,
      onCancel: handleCancel,
      description,
      documentationLink,
      submitError
    },
    children
  ));
};
export default CreatePage;
